"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var path = require("path");
var find_repo_root_1 = require("../../util/file-system/find-repo-root");
var GitBlob_1 = require("../models/GitBlob");
var GitCommit_1 = require("../models/GitCommit");
var not_a_git_repo_result_1 = require("./shared/not-a-git-repo-result");
exports.hashObjectCommand = function (fs, cwd, filePath, write, type) {
    if (write === void 0) { write = false; }
    if (type === void 0) { type = 'blob'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var repoRoot, fileBuffer, err_1, gitObj, sha1, gitObjDirectory, gitObjFilename, zippedFileContents, gitObjFilePath, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, find_repo_root_1.findRepoRoot(fs, cwd)];
                case 1:
                    repoRoot = _a.sent();
                    if (!repoRoot) {
                        return [2 /*return*/, not_a_git_repo_result_1.notAGitRepoResult];
                    }
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, fs.readFileAsync(path.resolve(filePath))];
                case 3:
                    fileBuffer = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    return [2 /*return*/, {
                            success: false,
                            message: "fatal: Cannot open " + filePath + ": No such file or directory",
                        }];
                case 5:
                    if (type === 'blob') {
                        gitObj = new GitBlob_1.GitBlob();
                    }
                    else if (type === 'commit') {
                        gitObj = new GitCommit_1.GitCommit();
                    }
                    else {
                        throw new Error("type " + type + " is not yet implemented");
                    }
                    gitObj.contents = fileBuffer.toString();
                    if (!write) return [3 /*break*/, 11];
                    sha1 = gitObj.getSha1();
                    gitObjDirectory = sha1.substring(0, 2);
                    gitObjFilename = sha1.substring(2);
                    return [4 /*yield*/, gitObj.serialize()];
                case 6:
                    zippedFileContents = _a.sent();
                    gitObjFilePath = path.join(repoRoot, '.git/objects', gitObjDirectory, gitObjFilename);
                    _a.label = 7;
                case 7:
                    _a.trys.push([7, 10, , 11]);
                    return [4 /*yield*/, fs.mkdirAsync(path.resolve(gitObjFilePath, '../'))];
                case 8:
                    _a.sent();
                    return [4 /*yield*/, fs.appendFileAsync(gitObjFilePath, zippedFileContents)];
                case 9:
                    _a.sent();
                    return [3 /*break*/, 11];
                case 10:
                    err_2 = _a.sent();
                    return [2 /*return*/, {
                            success: false,
                            message: "fatal: An error occurred while writing to " + gitObjFilePath + ": " + err_2,
                        }];
                case 11: return [2 /*return*/, {
                        success: true,
                        message: gitObj.getSha1(),
                        data: gitObj,
                    }];
            }
        });
    });
};
